import { Box } from '@mui/material';
import React, { useState } from 'react';
import { Palette } from 'Palette';
import { StyledInput } from '../styles/StyledInputs';

interface EditableFieldValueCellProps {
  rawValue: unknown;
  displayValue: React.ReactNode;
  inputType: 'text' | 'number' | 'date';
  onCommit: (newValue: string | number) => void;
}

const toInputString = (value: unknown): string =>
  value === null || value === undefined ? '' : String(value);

export const EditableFieldValueCell: React.FC<EditableFieldValueCellProps> = ({
  rawValue,
  displayValue,
  inputType,
  onCommit,
}) => {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(() => toInputString(rawValue));

  const commit = () => {
    setEditing(false);
    if (inputType === 'number') {
      const parsed = parseFloat(draft);
      if (!Number.isNaN(parsed)) {
        onCommit(parsed);
      }
      return;
    }
    onCommit(draft);
  };

  if (editing) {
    return (
      <StyledInput
        autoFocus
        size="small"
        type={inputType}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={commit}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            commit();
          }
          if (e.key === 'Escape') {
            setEditing(false);
          }
        }}
        sx={{ mt: 0, '& .MuiInputBase-input': { py: 0.5 } }}
      />
    );
  }

  return (
    <Box
      onClick={() => {
        setDraft(toInputString(rawValue));
        setEditing(true);
      }}
      sx={{
        cursor: 'text',
        borderRadius: '4px',
        px: 0.5,
        mx: -0.5,
        '&:hover': { backgroundColor: Palette.tone1.activeBg },
      }}
    >
      {displayValue}
    </Box>
  );
};

export default EditableFieldValueCell;
